export default __webpack_public_path__ + "static/media/52.889821ab.png";